import React, { useState, useEffect, useContext, useRef } from "react";
import { AdvancedMarker, APIProvider, Map, useMapsLibrary, Marker, Pin } from '@vis.gl/react-google-maps';
import axios from "axios";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { getFlexBacsList, getFlexBacsStatus, getFlexDashboard, getFlexLogs } from "services/ConfigServices";
import { dashboardText } from "variables/MBM/geb";
import { viewmenuData } from "variables/MBM/lists/geb";
import CustomSelect from "components/Input/CustomSelect.js";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { withStyles } from "@mui/styles";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { postMBMPointData } from "services/ConfigServices";
import MapComponent from "./MapComponent";
import {
  flexMapContainerStyle
} from "assets/jss/material-dashboard-pro-react/views/Maps/MapsStyle";
import ChartV2LineTimeAxisLive from "components/ChartV2/ChartV2LineTimeAxisLive";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { SmartGrid2, Logs, SmartGrid, Pilotage, Feuillenature, Danger, Gaz, Operator } from "components/CustomIcon/CustomIcon";
import Timeline from "@mui/icons-material/Timeline";
import classNames from 'classnames';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import { ListItemIcon } from '@mui/material';
import Typography from '@mui/material/Typography';
import './flex.css';

const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "0",
  paddingTop: "0",
  paddingBottom: "0px",
  paddingRight: "2px",
  paddingLeft: "2px",
  fontFamily: '"Source Sans Pro",sans-serif',
  color: "#000000",
  background: "transparent",
  boxShadow: "none",
};
const cardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  marginTop: "5px",
  marginBottom: "-5px"
};
const mapcardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  marginTop: "5px",
  marginBottom: "-5px"
};

const Ecowatt = styled.div`

`;

const FlexContainer = styled.div`
  margin-top: 10px;
`;


const ToolBar = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ToolBarRight = styled.div`
  display: flex;
`;

const useTableStyles = makeStyles(tablestyles);
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
}));

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const FlexComponent = () => {
  const classes = useStyles();
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_admin = permis.includes("mbm_geb_admin");
  const mbm_geb_control_access = permis.includes("mbm_geb_control_access");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [editionmode, setEditionmode] = useState(false);

  const [bacslist, setBacslist] = useState([]);
  const [bacsrequests, setBacsrequests] = useState([]);
  const [activesite, setActivesite] = useState();
  const [oversiteid, setOversiteid] = useState();
  const [ecowattnow, setEcowattnow] = useState();
  const [ecowattnext, setEcowattnext] = useState();
  const [co2now, setCo2now] = useState();
  const [co2before, setCo2before] = useState();
  const [chart, setChart] = useState();

  //flex list
  useEffect(() => {
    refresBacsList();
  }, [chartIdGroup]);



  const emptyBacs = () => {

  }
  const handleMarkerClick = (destination) => {
    setActivesite(destination);
    let datapointsraw = [];
    let datapoints1h = [];
    if (destination.assets && destination.assets.length > 0) {
      destination.assets.forEach((asset) => {
        if (asset.internalparameters?.datapoints && asset.internalparameters?.datamethod) {
          if (asset.internalparameters.datamethod === "raw")
            datapointsraw = datapointsraw.concat(asset.internalparameters.datapoints);
          else if (asset.internalparameters.datamethod === "1h") {
            datapoints1h = datapoints1h.concat(asset.internalparameters.datapoints);
          }
        }
      });
    }
    setPointidsraw(datapointsraw);
    setPointids1h(datapoints1h);
    setRefreshdata();
  }
  const onInfoWindowClose = () => {
    setActivesite();
    setPointidsraw([]);
    setPointids1h([]);
  }

  // const fetchData = async () => {
  //   const stream = axios.get(getFlexBacsStatusStream(chartIdGroup), {
  //     headers: { Authorization: `Bearer ${UserService.getToken()}` },
  //     responseType: 'stream'
  //   }).then((res) => {
  //     console.log(res);
  //   });
  //   console.log('await done');
  //   stream.data.on('data', data => {
  //     console.log(data);
  //   });
  //   stream.data.on('end', () => {
  //     console.log("stream done");
  //   });
  // }

  // const fetchData = async () => {
  //   const decoder = new TextDecoder();
  //   const response = await fetch(getFlexBacsStatusStream(chartIdGroup), {
  //     method: "GET",
  //     headers: { "Content-Type": "application/json", "Authorization": `Bearer ${UserService.getToken()}` },

  //   });
  //   const reader = response.body.getReader();
  //   // Stream processing
  //   while (true) {
  //     const { value, done } = await reader.read();
  //     if (done) break;
  //     const chunk = decoder.decode(value, { stream: true });
  //     console.log(chunk);
  //     // Handle the streamed chunks here
  //   }
  // }

  // const fetchData = async () => {
  //   const res = await fetch(getFlexBacsStatusStream(chartIdGroup), {
  //     method: "GET",
  //     headers: { "Content-Type": "application/json", "Authorization": `Bearer ${UserService.getToken()}` },

  //   });
  //   if (!res.ok) {
  //     throw res.statusText;
  //   }
  //   return res.json();
  // };

  const [refresh, setRefresh] = useState(false);
  const [timeoutfunc, setTimeoutfunc] = useState("");

  useEffect(() => {
    if (timeoutfunc) {
      clearTimeout(timeoutfunc);
      setTimeoutfunc();
    }
    axios
      .get(getFlexDashboard(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        console.log(res.data)
        refreshBacsStatus();
        if (res.data?.ecowatt && res.data.ecowatt.length > 0) {
          let timecompare = moment().add(-60, 'm');
          let now = moment();
          let nextslot;
          let currentslot = res.data.ecowatt.find((element) => moment(element.datatimestamp).isSameOrAfter(timecompare) && moment(element.datatimestamp).isSameOrBefore(now));
          if (currentslot && currentslot.value === 0) //Don't care about Green+ (0)
            currentslot.value = 1;
          setEcowattnow(currentslot || '');
          if (currentslot) {
            res.data.ecowatt.forEach(element => {
              if (element.value === 0) //Don't care about Green+ (0)
                element.value = 1;
              if (moment(element.datatimestamp).isAfter(now)
                && element.value !== currentslot.value
                && (!nextslot || moment(nextslot.datatimestamp).isAfter(moment(currentslot.datatimestamp)))) {
                nextslot = element;
              }
            });
          }
          setEcowattnext(nextslot || '');
        }
        if (res.data?.co2mix && res.data.co2mix.length > 0) {
          let timecompare = moment().add(-60, 'm');
          let currentslot = res.data.co2mix[0];
          if (moment(currentslot.datatimestamp).isSameOrAfter(timecompare)) {
            setCo2now(currentslot);
            if (res.data.ecowatt.co2mix > 1) {
              timecompare = moment().add(-120, 'm');
              let previouslot = res.data.co2mix[1];
              if (moment(currentslot.datatimestamp).isSameOrAfter(timecompare)) {
                setCo2before(previouslot);
              }
            }
          }
        }
        // setTimeoutfunc(setTimeout(() => {
        //   setRefresh(!refresh);
        // }, 300000));
      });
  }, [chartIdGroup, refresh]);

  const [refreshdata, setRefreshdata] = useState(false);
  const [timeoutfuncdata, setTimeoutfuncdata] = useState("");
  const [data, setData] = useState([]);
  const [logs, setLogs] = useState([]);
  const [pointidsraw, setPointidsraw] = useState([]);
  const [pointids1h, setPointids1h] = useState([]);
  useEffect(() => {
    if (timeoutfuncdata) {
      clearTimeout(timeoutfuncdata);
      setTimeoutfuncdata();
    }

    console.log("checkdata", pointidsraw.length, pointids1h.length);
    if (pointidsraw.length > 0) {
      let datebegin = moment().subtract(2, 'hour').format("YYYY-MM-DD HH:mm");
      let dateend = moment().format("YYYY-MM-DD HH:mm");
      let series = pointidsraw.map((point) => {
        return { color: point.color, name: point.name, dataid: point.id }
      });
      let charttmp = {
        series: series,
        xaxisscale: 'time',
        xaxistimetick: 'hour',
        yaxis1unit: 'kWh',
      }
      setChart(charttmp);

      let request = {
        live: 'yes',
        datebegin,
        dateend,
        method: 'raw',
        pointids: pointidsraw.map((point) => point.id),
        app: "" //to delete after maj
      }
      console.log(pointidsraw);
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          pointidsraw.forEach((point) => {
            if (res.data[point.id]) {
              let sorteddata = res.data[point.id].sort((a, b) => a.date - b.date);
              let coef = point.coef || 1;
              sorteddata.forEach((d) => {
                d.value = d.value.replace(",", ".");
                d.value = ""+(Number(d.value) * coef);
              });
              sorteddata = sorteddata.filter((data) => Number(data.value) > 0.0000001 && Number(data.value) < 200000);
              //console.log(sorteddata);
              res.data[point.id] = sorteddata;
            }
          });
          //console.log(res.data);
          setData(res.data);
        });
    }
    else if (pointids1h.length > 0) {  //else if because we cannot have raw and 1h at the same time on the chart, so assets must have same def
      let datebegin = moment().subtract(24, 'hour').format("YYYY-MM-DD HH:mm");
      let dateend = moment().format("YYYY-MM-DD HH:mm");
      let series = pointids1h.map((point) => {
        return { color: point.color, name: point.name, dataid: point.id }
      });
      let charttmp = {
        series: series,
        xaxisscale: 'time',
        xaxistimetick: 'hour',
        yaxis1unit: 'kWh',
      }
      setChart(charttmp);

      let request = {
        live: 'yes',
        datebegin,
        dateend,
        method: '1h',
        pointids: pointids1h.map((point) => point.id),
        app: "" //to delete after maj
      }
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          pointids1h.forEach((point) => {
            if (res.data[point.id]) {
              let sorteddata = res.data[point.id].sort((a, b) => a.date - b.date);
              res.data[point.id] = sorteddata;
            }
          });
          setData(res.data);
        });
    }
    if (activesite) {
      axios
        .get(getFlexLogs(activesite.bacsid), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setLogs(res.data?.logs || []);
        });
    }


    if (activesite) {
      setTimeoutfuncdata(setTimeout(() => {
        setRefreshdata(!refreshdata);
      }, 10000));
    }
    else
      console.log("exit check data");
  }, [chartIdGroup, refreshdata, pointids1h, pointidsraw]);


  // const [refresh, setRefresh] = useState(false);
  // const [timeoutfunc, setTimeoutfunc] = useState("");
  // const [data, setData] = useState([]);
  // const [logs, setLogs] = useState([]);
  // useEffect(() => {
  //   if (timeoutfunc) {
  //     clearTimeout(timeoutfunc);
  //     setTimeoutfunc();
  //   }
  //   axios
  //     .get(getFlexBacsStatusStream(chartIdGroup), {
  //       headers: {
  //         Authorization: `Bearer ${UserService.getToken()}`,
  //       },
  //     })
  //     .then((res) => {
  //       //console.log(res.data)

  //       let tmpdata = [...data];
  //       let base = 4000;
  //       if (tmpdata.length > 5)
  //         base = 2500;
  //       let newdata = {
  //         timestamp: (moment().unix()) * 1000,
  //         meter1: base + Math.floor(Math.random() * 50),
  //       }
  //       if (tmpdata.length > 9)
  //         tmpdata.shift();
  //       tmpdata.push(newdata);
  //       setData(tmpdata);
  //       let alea = Math.floor(Math.random() * 10)
  //       let newlog = {
  //         date : moment().format("DD/MM/yyyy HH:mm:ss"),
  //         source : alea<6 ? "Energy Pool" : "BACS Kergrid",
  //         text : alea<6 ? "Activation de la charge demandée" : "Activation de la charge",
  //         icon : alea<6 ? "Grid" : "BACS",
  //       }
  //       let tmplogs = [...logs];
  //       tmplogs.unshift(newlog);
  //       setLogs(tmplogs);

  //       setTimeoutfunc(setTimeout(() => {
  //         setRefresh(!refresh);
  //       }, 5000));
  //     });
  // }, [chartIdGroup, refresh]);

  const refreshBacsStatus = (selectedid) => {
    if (chartIdGroup > 0) {
      emptyBacs();
      axios
        .get(getFlexBacsStatus(chartIdGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setBacsrequests(res.data?.requests || []);
        });
    }
  }
  const refresBacsList = (selectedid) => {
    if (chartIdGroup > 0) {
      emptyBacs();
      axios
        .get(getFlexBacsList(chartIdGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setBacslist(res.data?.bacs || []);
        });
    }
  }



  return (
    <FlexContainer>
      <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">
        {/* <GridItem xs={12} sm={12} md={12} lg={12}>
          <ToolBar>
            <div style={{ display: "flex" }}>
              toolbar
            </div>
            <ToolBarRight>

            </ToolBarRight>
          </ToolBar>
        </GridItem> */}
        <GridItem xs={12} sm={12} md={activesite ? 6 : 12} lg={activesite ? 6 : 12}>
          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '5px', background: '#242f3e' }}>
            <CardHeader color="success" icon style={mapcardHeaderStyle}>
              <div style={{ display: "flex" }}>
                <SmartGrid2 style={{ marginTop: "5px" }} />
                <h4 className={classes.cardIconTitleSimpleCardDark}>{"Carte des sites"}</h4>
              </div>
              {
                co2now ? <div className={classNames("eco2div")}>
                  <div>
                    {
                      co2now.value < 50 ? <Feuillenature /> :
                        co2now.value < 100 ? <Gaz /> :
                          <Danger />
                    }
                  </div>
                  <div className={classNames("eco2text")}>
                    <div className={classNames("eco2val")}>{co2now.value}</div>
                    <div className={classNames("eco2unit")}>g CO
                      <sub>2</sub>
                      eq /kWh
                    </div>
                  </div>
                </div> :
                  <></>
              }
              <Ecowatt
                className={classNames("ecowatt", ecowattnow ? "ecowattnow" + ecowattnow.value : 'ecowattnow', ecowattnext ? "ecowattnext" + ecowattnext.value : 'ecowattnext')}
              >
                EcoWatt
                {/* {ecowattnow ? ecowattnow.value : 'rien'}
                {ecowattnext ? ecowattnext.value : 'rien'} */}
              </Ecowatt>
            </CardHeader>
            <CardBody style={{ height: '100%', userSelect: 'none' }} id={"4654655"}>
              <div style={flexMapContainerStyle} className="flexmap">
                <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                  <MapComponent
                    bacslist={bacslist}
                    bacsrequests={bacsrequests}
                    onMarkerClickCallback={handleMarkerClick}
                    activesite={activesite}
                    overSiteId={oversiteid}
                    onInfoWindowClose={onInfoWindowClose}
                  >

                  </MapComponent>
                </APIProvider>
              </div>
            </CardBody>
          </Card>
        </GridItem>
        {
          activesite ?
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card raised={false} chart style={{ marginTop: '15px', marginBottom: '40px', background: '#242f3e' }}>
                    <CardHeader color="success" icon style={cardHeaderStyle}>
                      <Timeline style={{ marginTop: "5px" }} />
                      <h4 className={classes.cardIconTitleSimpleCardDark}>{"Evolution de la consommation de " + activesite.name}</h4>
                    </CardHeader>
                    <CardBody style={{ height: '370px', userSelect: 'none' }} id={"4654654"}>
                      <ChartV2LineTimeAxisLive
                        chart={chart}
                        displayeddata={data}
                      />
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card raised={false} chart style={{ marginTop: '15px', marginBottom: '40px', background: '#242f3e' }}>
                    <CardHeader color="success" icon style={cardHeaderStyle}>
                      <Logs style={{ marginTop: "5px" }} />
                      <h4 className={classes.cardIconTitleSimpleCardDark}>{"Journal d'évènement de " + activesite.name}</h4>
                    </CardHeader>
                    <CardBody style={{ height: '370px', userSelect: 'none', overflow: "auto" }} id={"4654654"}>
                      <List sx={{ width: '100%' }}>
                        {
                          logs.map((log) => {
                            return <ListItem alignItems="flex-start" style={{ color: "white", padding: "2px" }}>
                              <ListItemIcon style={{ color: "white", marginTop: "12px" }}>
                                {
                                  log.source === 'Grid' ? <SmartGrid2 style={{ fontSize: "1.8rem" }} /> :
                                    log.source === 'BACS' ? <Pilotage style={{ fontSize: "1.8rem" }} /> :
                                      log.source === 'operator' ? <Operator style={{ fontSize: "1.8rem" }} /> :
                                        <></>
                                }

                              </ListItemIcon>
                              <ListItemText

                                primary={log.author}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{ display: 'inline' }}
                                      component="span"
                                      variant="body2"
                                      color="white"
                                    >
                                      {moment(log.date).format("YYYY-MM-DD HH:mm") + " - " + log.message}
                                    </Typography>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                          })
                        }
                      </List>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </GridItem>
            : <></>
        }

      </GridContainer>
      <NotificationContainer />
    </FlexContainer>
  );
};

export default FlexComponent;
